const ConversionBoxQuickPreview = `
	var conversionBoxQuickPreview = {
		openQuickPreview: async (event, i, page) => {
			event.preventDefault();
			event.stopPropagation();
		
			const productHit = roundViewInstantSearch.productResults[page]?.hits[i];
			if (!productHit) return;
		
			const product = productHit.document;
			roundViewInstantSearch.previewProductData = product;
			roundViewInstantSearch.previewSelectedOptions = {};
		
			// Remove existing overlay if present
			document.querySelector('.cbQuickPreviewOverlay')?.remove();
		
			// Helper to create elements with optional class(es)
			const createElem = (tag, classNames = [], innerHTML = '') => {
				const el = document.createElement(tag);
				if (classNames.length) el.classList.add(...classNames);
				if (innerHTML) el.innerHTML = innerHTML;
				return el;
			};
		
			// Overlay and Modal structure
			const overlay = createElem('div', ['cbQuickPreviewOverlay']);
			const modal = createElem('div', ['cbQuickPreviewModal']);
			overlay.appendChild(modal);
			document.body.appendChild(overlay);
		
			// Close button
			const closeBtn = createElem('button', ['cbQuickPreviewCloseModal'], '&times;');
			closeBtn.onclick = () => {
				overlay.remove();
				roundViewInstantSearch.previewProductData = null;
				roundViewInstantSearch.previewSelectedOptions = {};
			};
			modal.appendChild(closeBtn);
		
			// Left Pane: Image sliders
			const leftPane = createElem('div', ['cbQuickPreviewLeftModal']);
			const mainSlider = createElem('div', ['swiper', 'main-slider']);
			const mainWrapper = createElem('div', ['swiper-wrapper']);
		
			product.product_images.forEach(url => {
				const slide = createElem('div', ['swiper-slide']);
				const img = createElem('img');
				img.src = url;
				img.style.borderRadius = '8px';
				slide.appendChild(img);
				mainWrapper.appendChild(slide);
			});
			mainSlider.appendChild(mainWrapper);
		
			const nextBtn = createElem('div', ['swiper-button-next']);
			const prevBtn = createElem('div', ['swiper-button-prev']);
			mainSlider.append(prevBtn, nextBtn);
		
			const pagination = createElem('div', ['swiper-pagination']);
			const thumbSlider = createElem('div', ['swiper', 'thumbs-slider']);
			const thumbWrapper = createElem('div', ['swiper-wrapper']);
		
			product.product_images.forEach(url => {
				const thumbSlide = createElem('div', ['swiper-slide']);
				const thumbImg = createElem('img');
				thumbImg.src = url;
				thumbSlide.appendChild(thumbImg);
				thumbWrapper.appendChild(thumbSlide);
			});
			thumbSlider.appendChild(thumbWrapper);
		
			leftPane.append(mainSlider, pagination, thumbSlider);
		
			// Right Pane: Product details
			const rightPane = createElem('div', ['cbQuickPreviewRightModal', 'rvsResultListItem']);
			rightPane.setAttribute('data-product-id', product.id);
		
			const categoryName = createElem('div', ['cbPreviewCatName'], roundViewInstantSearch.categoryName || '');
			const title = createElem('h2', ['cbPreviewTitle'], product.name);
			const price = createElem('div', ['cbPreviewPrice', 'rvSRPriceList'], roundViewInstantSearch.formatPrice(product));
		
			const previewMiddleWrap = createElem('div', ['cbPreviewRightMiddleWrap']);
			const notFoundBadge = createElem('div', ['addToCartError']);
			notFoundBadge.style.display = 'none';
		
			const qtyWrapper = createElem('div', ['cbPreviewQtyWrapper'], \`
				<label class="cbPreviewQtyLabel">Qty</label>
				<div class="cbPreviewQtyInput">
					<button class="cbPreviewQtyCount cbPreviewQtyCount--minus" data-action="minus" type="button">-</button>
					<input class="cbPreviewPrdQty cbPrdQty" type="number" name="cbPreviewPrdQty" min="0" max="1000" value="1">
					<button class="cbPreviewQtyCount cbPreviewQtyCount--add" data-action="add" type="button">+</button>
				</div>
			\`);
		
			const addToCartBtnWrap = createElem('div', ['cbAddToCartBtnWrap']);
			const addToCartBtn = createElem('button', ['cbPreviewAddCart'], 'Add to Cart');
			addToCartBtn.addEventListener('click', (e) => {
				window.roundViewInstantSearch.addToCart(e, product, true);
			});
			addToCartBtnWrap.appendChild(addToCartBtn);
			previewMiddleWrap.append(qtyWrapper, addToCartBtnWrap);
		
			const descriptionWrapper = createElem('div', ['cbPreviewDescWrap']);
			const descTitle = createElem('h4', ['cbPreviewDescTitle'], 'Description');
			const descContent = createElem('div', ['cbPreviewDescOuter']);
			descContent.innerHTML = product.html_description;
			descriptionWrapper.append(descTitle, descContent);
		
			const optionContainer = createElem('div', ['cbOptionContainer']);
			if (product.variants.length > 1) {
				roundViewInstantSearch.renderProductOptions(product.option_type, optionContainer);
			}
		
			rightPane.append(categoryName, title, price, optionContainer, previewMiddleWrap, notFoundBadge, descriptionWrapper);
			modal.append(leftPane, rightPane);
		
			// Swiper initialization
			const thumbSwiper = new Swiper('.thumbs-slider', {
				slidesPerView: 4,
				spaceBetween: 10,
				watchSlidesProgress: true,
			});
		
			const mainSwiper = new Swiper('.main-slider', {
				spaceBetween: 10,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				thumbs: { swiper: thumbSwiper },
			});
		
			// Overlay click to close
			overlay.onclick = (e) => {
				if (e.target === overlay) {
					overlay.remove();
					roundViewInstantSearch.previewProductData = null;
					roundViewInstantSearch.previewSelectedOptions = {};
				}
			};
		
			// Post-render functions
			roundViewInstantSearch.quickPreviewQtyChange();
			roundViewInstantSearch.checkProductAvailabilty();
		}
	}
`
export default ConversionBoxQuickPreview;